// LandingPage.js

import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useSession } from '../contexts/SessionContext';
import { useAuth } from '../contexts/AuthContext';
import { ROUTES } from '../routes/routes';
import DesignCard from '../components/DesignCard';
import './css/LandingPage.css';

function LandingPage() {
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth();
    const { createSession, loading, error } = useSession();
    const [selectedDesign, setSelectedDesign] = useState(null);

    const designs = [
        {
            id: 'Design1',
            name: 'Spinning Vinyl',
            description: 'Classic rotating disk design',
            badge: 'Popular',
            isPremium: false
        },
        {
            id: 'Design2',
            name: 'Audio Wave',
            description: 'Dynamic waveform visualization',
            badge: 'Premium',
            isPremium: true
        },
        {
            id: 'Design3',
            name: 'EQ',
            description: 'Graphical EQ visualization',
            badge: 'Premium',
            isPremium: true
        }
    ];

    const handleDesignSelection = async (designId) => {
        const design = designs.find(d => d.id === designId);
        
        // Prevent selection of premium designs
        if (design && design.isPremium) {
            // TODO: Show premium upgrade modal or redirect to pricing
            return;
        }
        
        setSelectedDesign(designId);
        try {
            const session = await createSession(designId);
            navigate(ROUTES.Session(session.sessionId));
        } catch (err) {
            setSelectedDesign(null);
        }
    };

    return (
        <div className="landing-container">
            {/* Header */}
            <header className="landing-header">
                <div className="header-content">
                    <Link to={ROUTES.Home()} className="logo">
                        <img src="/pink_logo.png" alt="Render FM Logo" className="landing-logo" />
                        <h1>Render FM</h1>
                    </Link>
                    <nav className="header-nav">
                        {isAuthenticated ? (
                            <Link to={ROUTES.Settings()} className="nav-link nav-link-primary">My Account</Link>
                        ) : (
                            <>
                                <Link to={ROUTES.Login()} className="nav-link">Login</Link>
                                <Link to={ROUTES.SignUp()} className="nav-link nav-link-primary">Sign Up</Link>
                            </>
                        )}
                    </nav>
                </div>
            </header>

            {/* Hero Section */}
            <div className="hero-section">
                <div className="hero-content">
                    <h1 className="hero-title">
                        Create Music Videos
                        <span className="text-gradient"> in Minutes</span>
                    </h1>
                    <p className="hero-description">
                        Upload your artwork and audio, customize colors, and export 
                        professional videos perfect for social media.
                    </p>
                </div>
            </div>

            {/* Design Selection */}
            <div className="designs-section">
                <h2 className="section-title">Choose Your Design</h2>
                
                {error && (
                    <div className="error-message">
                        <span className="error-icon">⚠️</span>
                        {error}
                    </div>
                )}

                <div className="design-grid">
                    {designs.map((design) => (
                        <DesignCard
                            key={design.id}
                            design={design}
                            onClick={handleDesignSelection}
                            loading={loading && selectedDesign === design.id}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default LandingPage;
